import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField, Toggle } from "material-ui"
import strings from "../../localization/strings"
import { IAccrualAdjustment } from "../../models"
import * as utils from "../../helpers/utils"
import cloneDeep from "lodash/cloneDeep"

interface IProps {
    editAdjustment?: boolean
    selectedAdjustment?: IAccrualAdjustment
    handleClose(): void
    handleAddOrUpdate(adjustment: IAccrualAdjustment): void
}
interface IState {
    adjustment: string
    errorAdjustment: string
    allowManualAdjustment: boolean
    adjustmentValue: number
}

export default class AdjustmentDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            adjustment: props.editAdjustment && props.selectedAdjustment ? props.selectedAdjustment.Adjustment : "",
            errorAdjustment: "",
            allowManualAdjustment: props.editAdjustment && props.selectedAdjustment ? props.selectedAdjustment.AllowManualAdjustment : false,
            adjustmentValue: props.editAdjustment && props.selectedAdjustment ? props.selectedAdjustment.AdjustmentValue : 0,
        }
        autobind(this)
    }

    getAdjustmentPayload() {
		const payload = {
		  	Id: utils.guid(),
			Adjustment: this.state.adjustment.trim(),
			AllowManualAdjustment: this.state.allowManualAdjustment,
			AdjustmentValue: this.state.adjustmentValue
		} as IAccrualAdjustment
		return payload
	}
	
	handleSave() {
        if (this.checkValidate()) {
            if (this.props.editAdjustment) {
                const adjustmentPayload: IAccrualAdjustment = cloneDeep(this.props.selectedAdjustment)
                adjustmentPayload.Adjustment = this.state.adjustment.trim()
                adjustmentPayload.AllowManualAdjustment = this.state.allowManualAdjustment
                adjustmentPayload.AdjustmentValue = this.state.adjustmentValue
                this.props.handleAddOrUpdate(adjustmentPayload)
            } else {
                this.props.handleAddOrUpdate(this.getAdjustmentPayload())
            }
            
        }
	}

	checkValidate() {
		let isValidate = true
		if (!this.state.adjustment.trim()) {
			this.setState({ errorAdjustment: strings.This_field_is_required })
			isValidate = false
		}
		else {
			this.setState({ errorAdjustment: "" })
        }
        return isValidate
	}

    render() {
        return (
            <Dialog
                open
                title={this.props.editAdjustment ? strings.Edit_Accrual_Adjustment : strings.Add_Accrual_Adjustment}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                <FlatButton
                    data-intercom-target={"menu-AccountSettings-AccrualAdjustmentRules-Btn-CloseAdjustmentDialog"}
                    label={strings.CANCEL}
                    secondary
                    onClick={this.props.handleClose}
                />,
                <FlatButton
                    data-intercom-target={"menu-AccountSettings-AccrualAdjustmentRules-Btn-SaveAdjustment"}
                    label={strings.SAVE}
                    primary
                    disabled={!this.checkValidate}
                    onClick={this.handleSave}
                />
                ]}
            >
                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    <br></br>
                    <Toggle
                        data-intercom-target={"menu-AccountSettings-AccrualAdjustmentRules-Add-Toggle-AllowManualAdjustment"}
                        toggled={this.state.allowManualAdjustment}
                        onToggle={(event, value) => this.setState({ allowManualAdjustment: value }, () => this.checkValidate())}
                        labelPosition="left"
                        label={strings.Allow_Manual_Adjustment}
                        style={{ maxWidth: 450 }}
                    />
                    <TextField
                        data-intercom-target={"menu-AccountSettings-AccrualAdjustmentRules-Add-Entry-Adjustment"}
                        floatingLabelText={strings.Adjustment}
                        value={this.state.adjustment}
                        onChange={(e, value) => { this.setState({ adjustment: value }, () => this.checkValidate()) }}
                        errorText={this.state.errorAdjustment}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                        fullWidth={true}
                    />
                    <TextField
                        data-intercom-target={"menu-AccountSettings-AccrualAdjustmentRules-Add-Entry-AdjustmentValue"}
                        floatingLabelText={strings.Adjustment_Value}
                        value={this.state.adjustmentValue}
                        onChange={(e, value) => { this.setState({ adjustmentValue: value }) }}
                        fullWidth={true}
                        type={"number"}
                    />
                </div>
            </Dialog>
        )
    }
}